import { Button, Box, Typography } from '@mui/material'
import PhoneIcon from '@mui/icons-material/Phone'
import styles from './PhoneCallButtons.module.scss'

interface PhoneCallButtonsProps {
  patientPhoneNumber?: string | null
  pharmacyPhoneNumber?: string | null
}

const PhoneCallButtons = ({
  patientPhoneNumber,
  pharmacyPhoneNumber,
}: PhoneCallButtonsProps) => {
  return (
    <Box className={styles.container}>
      <Box className={styles.buttonWrapper}>
        <Button
          variant="contained"
          fullWidth
          startIcon={<PhoneIcon />}
          href={`tel:${patientPhoneNumber}`}
          className={styles.button}
          disabled={!patientPhoneNumber}
        >
          Call/Text RN
          {patientPhoneNumber && (
            <Typography variant="body2" className={styles.phoneNumber}>
              {patientPhoneNumber}
            </Typography>
          )}
        </Button>
        {!patientPhoneNumber && (
          <Typography variant="caption" className={styles.helperText}>
            No RN phone number available
          </Typography>
        )}
      </Box>

      <Box className={styles.buttonWrapper}>
        <Button
          variant="contained"
          fullWidth
          startIcon={<PhoneIcon />}
          href={`tel:${pharmacyPhoneNumber}`}
          className={styles.button}
          disabled={!pharmacyPhoneNumber}
        >
          Call MD
          {pharmacyPhoneNumber && (
            <Typography variant="body2" className={styles.phoneNumber}>
              {pharmacyPhoneNumber}
            </Typography>
          )}
        </Button>
        {!pharmacyPhoneNumber && (
          <Typography variant="caption" className={styles.helperText}>
            No MD phone number available
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default PhoneCallButtons
